import { LOGOUT_MUTATION} from '../graphql/mutations/user/mutations';
import { apiRequests} from '../services/api';

export const _logout =async () => {
    try {
        const token = localStorage.getItem("token");  
        const response = await apiRequests(LOGOUT_MUTATION, {}, {
            Authorization: `Bearer ${token}` // Enviar el token en el header
        });
        // console.log('12',response);
            localStorage.removeItem("token");
            localStorage.removeItem("user"); // Eliminar CSRF
            window.location.href="/";
        
    } catch (e){
        console.log("Se presento el siguiente error, ".e);
    }
}